"use strict";

exports.__esModule = true;
var _LayoutButtons = require("./LayoutButtons");
Object.keys(_LayoutButtons).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _LayoutButtons[key]) return;
  exports[key] = _LayoutButtons[key];
});